import type IAiChatContext from 'store/slices/aiChats/interfaces/IAiChatContext';

/**
 * Date rules for a dossier write live in screen customData.
 * The Screen line is data, not an instruction.
 * Copy the rules onto this turn's user text so a later write still sees them.
 */
export default function appendDossierFactTypes(
  text: string,
  chatContext: IAiChatContext | undefined,
): string {
  const customData = chatContext?.screen?.customData;
  if (!customData || customData.taskKind !== 'company_dossier') {
    return text;
  }
  const { factTypes } = customData;
  const rules = typeof factTypes === 'string' ? factTypes.trim() : '';
  if (!rules || text.includes(rules)) {
    return text;
  }

  return text ? `${text} ${rules}` : rules;
}
